var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card w-100" }, [
      _c("div", [
        _vm.resource.cover
          ? _c("img", {
              staticClass: "img-fluid",
              attrs: {
                src:
                  _vm.resource.cover == null
                    ? "/images/cover.png"
                    : _vm.resource.cover.url,
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-content p-1" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("span", { staticClass: "font-large-1" }, [
              _vm._v(_vm._s(_vm.resource.title)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 d-flex align-items-center" }, [
            _c("div", { staticClass: "ml-auto" }, [
              _c(
                "button",
                {
                  staticClass: "btn-sm btn-outline-warning resource-rating",
                  attrs: {
                    "data-toggle": "modal",
                    "data-target": "#registerModal",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.__("resource.form.buttons.view_rating")) +
                        "\n                        "
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "breakAll pt-1" }, [
              _c("span", {
                staticClass: "breakAll image-resize",
                domProps: {
                  innerHTML: _vm._s(_vm.resource.resource_description),
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex border-top border-bottom align-items-center mt-1 owner-info",
              },
              [
                _c("div", { attrs: { id: "pt-1" } }, [
                  _c("img", {
                    staticClass: "round",
                    attrs: {
                      src:
                        _vm.resource.owner.avatar !== null
                          ? _vm.resource.owner.avatar.url
                          : "/images/avatar.png",
                      alt: "avatar",
                      height: "40",
                      width: "40",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "p-1" }, [
                  _c(
                    "span",
                    {
                      staticClass: "user-name text-bold-600",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#registerModal",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.resource.owner.first_name) +
                          " " +
                          _vm._s(_vm.resource.owner.last_name)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _c("span", { staticClass: "font-size-3 text-muted" }, [
                    _vm._v(_vm._s(_vm.resource.owner.position)),
                  ]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c(
              "button",
              {
                staticClass:
                  "download-button btn btn-primary waves-effect waves-light form-control mt-05",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _c("i", { staticClass: "fa fa-download" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.__("resource.form.buttons.download")) +
                    "\n                        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "p-2",
              staticStyle: { display: "none" },
              attrs: { id: "progress" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between border-top pl-05 pr-05",
        },
        [
          _c("div", { staticClass: "p-05" }, [
            _c("i", {
              staticClass: "fa fa-thumbs-o-up",
              attrs: {
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            }),
            _vm._v(
              "\n                 " +
                _vm._s(_vm.resource.likes === 0 ? "" : _vm.resource.likes) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "p-05" }, [
            _c(
              "span",
              {
                staticClass: "comment-button",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _c("i", { staticClass: "fa fa-comment-o" }),
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.resource.comments === 0 ? "" : _vm.resource.comments
                    ) +
                    "\n                    " +
                    _vm._s(
                      _vm.resource.comments === 1
                        ? _vm.__("globals.comment")
                        : _vm.__("globals.comments")
                    ) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("guest-social-share", {
                attrs: { social: _vm.resource.social },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }